import {Component, Input, OnDestroy} from '@angular/core';
import {ResponsesService} from "../../../common/services/responses/responses.service";
import {ResponseForm} from "../../../common/components/form/models/responsedemat.model";
import {SubSink} from "@Common/core/utils/subsink";
import {PubSubService} from "@Common/core/services";
import {finalize} from "rxjs/operators";


@Component({
  selector: 'app-download-pdf',
  template: `
    <button mat-icon-button
            color="primary"
            (click)="downloadPdf()"
            [matTooltip]="'Télécharger la demande en pdf'">
      <i class="fa fa-file-pdf-o fa-2x" aria-hidden="true"></i>
    </button>
    <button mat-icon-button
            *ngIf="response?.has_files"
            color="primary"
            (click)="downloadZip()"
            [matTooltip]="'Télécharger la demande en zip'">
      <i class="fa fa-file-archive-o fa-2x" aria-hidden="true"></i>
    </button>
  `
})
export class DownloadPdfComponent implements OnDestroy {

  @Input() response: ResponseForm;
  subSink = new SubSink();
  constructor(
    private pubSubSvc: PubSubService,
    private responsesSvc: ResponsesService)
  { }

  downloadPdf() {
    if (this.response) {
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.responsesSvc.downloadDemande(this.response)
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe();
    }
  }

  downloadZip() {
    if (this.response) {
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.responsesSvc.downloadDemande(this.response, 'zip')
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe();
    }
  }

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

}
